/* models/callbacks/index */ function _(require, module, exports) {
    var customjs_1 = require(91) /* ./customjs */;
    exports.CustomJS = customjs_1.CustomJS;
    var open_url_1 = require(93) /* ./open_url */;
    exports.OpenURL = open_url_1.OpenURL;
}
